// Disables the submit button while the name input is empty or whitespace-
// only. Used by the single-kind create modals (customer / project / task)
// on the project browser so the primary CTA can't fire on an empty name.
//
// The combined "project or task" modal uses quick_create_controller for
// the same purpose — it has two submit buttons and its own form-less fetch
// flow, so it keeps its own validity logic. Both controllers apply the
// same disabled appearance to the buttons they manage, so the user sees a
// consistent "type a name to enable" affordance across all four modals.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  static targets = ["input", "submit"]
  declare readonly inputTarget: HTMLInputElement
  declare readonly submitTarget: HTMLButtonElement

  connect(): void {
    this.updateValidity()
  }

  inputChanged(): void {
    this.updateValidity()
  }

  private updateValidity(): void {
    this.submitTarget.disabled = this.inputTarget.value.trim().length === 0
  }
}
